import { fetcher } from "helpers/fetcher";

import {
  TGetBUStaffMemberFilterReq,
  TGetBUStaffMemberFilterRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUStaffMemberFilter = async (
  params?: TGetBUStaffMemberFilterReq
) => {
  return await fetcher<TGetBUStaffMemberFilterRes, TGetBUStaffMemberFilterReq>(
    ENDPOINT.BU.GET_BU_STAFF_MEMBER_FILTER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_STAFF_MEMBER_FILTER.version,
        [API_HEADER.BU_ID]: params?.idBu,
      },
    }
  );
};

export const queryGetBUStaffMemberFilter = async (
  params?: TGetBUStaffMemberFilterReq
) => {
  return (await getBUStaffMemberFilter(params)).data;
};

queryGetBUStaffMemberFilter._key = (params?: TGetBUStaffMemberFilterReq) => [
  ENDPOINT.BU.GET_BU_STAFF_MEMBER_FILTER.url,
  params,
];
